import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../../../components/logo/logo";
import loginPgImg from "../../assets/images/login_pg.svg";
import ArrowButton from "../../ui-elements/arrow-button/arrow-button";
import LoginCarousel from "./login-carousel/login-carousel";
import styles from "./login-layout.module.scss";
import PublicThemeDropdown from "./public-theme-dropdown/public-theme-dropdown";

interface IProps {
  title: string;
  subTitle?: string | JSX.Element;
  children: JSX.Element;
  showBackButton?: boolean;
  showCarousel?: boolean;
  rightSideContent?: JSX.Element | undefined;
}

const LoginLayout = (props: IProps) => {
  const {
    showCarousel = false,
    rightSideContent = showCarousel ? (
      <LoginCarousel />
    ) : (
      <div
        className={styles.staticImageWrapper}
        id="login-static-image-wrapper"
      >
        <img
          src={loginPgImg}
          alt="login image"
          className={styles.staticImage}
          id="login-static-image"
        />
      </div>
    ),
  } = props;

  const navigate = useNavigate();

  return (
    <Container fluid className="p-0" id="login-layout-container">
      <PublicThemeDropdown />
      <Row className="g-0 min-vh-100">
        <Col
          lg={6}
          md={12}
          className={`d-flex flex-column justify-content-center align-items-center py-3 py-sm-5 ${styles.leftCol}`}
        >
          <div className={styles.formContainer}>
            <div className="text-center mb-4">
              <Logo />
            </div>
            <div className="d-flex align-items-center justify-content-center gap-4 mb-3">
              {props.showBackButton && (
                <ArrowButton
                  onBack={() => {
                    navigate(-1);
                  }}
                />
              )}
              <h1 className={styles.title} id="login-page-title">
                {props.title}
              </h1>
            </div>
            {props.subTitle && (
              <div
                className={`${styles.subTitle} text-center mb-4`}
                id="login-page-subtitle"
              >
                {props.subTitle}
              </div>
            )}
            <div className={styles.formContent} id="login-form-content">
              {props.children}
            </div>
          </div>
        </Col>
        <Col
          lg={6}
          className={`d-none d-lg-flex flex-column justify-content-center align-items-center ${styles.rightCol}`}
        >
          {rightSideContent}
        </Col>
      </Row>
    </Container>
  );
};

export default LoginLayout;
